import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function DocuCraft() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="DocuCraft AI"
      teaser="Generate, update, and format docs and guides with AI assistance."
      imageSrc="/images/coming-soon/trendpulse.png"
    />
    </div>
    </AppShell>
  );
}

